import Cookies from 'js-cookie';
import tool from './utils/tool';

const config = tool.data.get('config') || {};

const configHas = function (name) {
    const data = Cookies.get('config.' + name)
    return data != '' && data != undefined && data != 'undefined'
}

const confiGet = function (name) {
    return Cookies.get('config.' + name) == 'true';
}

export const WebFileName = (function () {
    if (window.location.href.indexOf('localhost') < 0) {
        let url = '';
        if (window.location.href.indexOf('?') > 0) {
            url = window.location.href.split('?')[0];
        }

        if (url && url.indexOf('#') > 0) {
            url = url.split('#')[0];
        } else {
            if (window.location.href.indexOf('#') > 0) {
                url = window.location.href.split('#')[0];
            }
        }

        /**
         * @type {array}
         */
        const arr = url.split('/')
        return arr[arr.length - 1] ? './' + arr[arr.length - 1] + '/' : './';
    }
    return './';
})


// http://cmy.private.chenmds.cn/index/v1/store/h5/index/getRollNavList

export default Object.assign(config, {

    title: '沉梦云商城Pro后台管理',

    ENV: process.env,
    // 数据储存前缀
    DATA_PREFIX: 'cmyiotuser',

    /**
     * @type {string} Api地址
     * @description Api地址
     */
    API_URL: process.env.NODE_ENV == 'development' ? ' https://iot.cmyo.cn/' : WebFileName(),

    /**
     * @type {boolean} true | false
     * @description Whether show the settings right-panel
     */
    showSettings: true,

    /**
     * @type {boolean} true | false
     * @description Whether need tagsView
     */
    tagsView: configHas('tagsView') ? confiGet('tagsView') : true,

    /**
     * @type {boolean} true | false
     * @description Whether fix the header
     */
    fixedHeader: configHas('fixedHeader') ? confiGet('fixedHeader') : true,

    /**
     * @type {boolean} true | false
     * @description Whether show the logo in sidebar
     */
    logo: configHas('logo') ? confiGet('logo') : require("@/assets/images/logo.png"),

    /**
     * @type {string | array} 'production' | ['production', 'development']
     * @description Need show err logs component.
     * The default is only used in the production env
     * If you want to also use it in dev, you can pass ['production', 'development']
     */
    errorLog: 'production'
});


// WEBPACK FOOTER //
// ./src/settings.js